import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, ToggleButton, ToggleButtonGroup, Select, MenuItem, TextField, SelectChangeEvent, Grid, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { createRedirect } from "../../../store/redirects";
import { importTarget } from "../../../store/imports";
import { importQuery } from "../../../store/imports";
import { importCode } from "../../../store/imports";
import { importTargetType } from "../../../store/imports";
interface RedirectImportTableRowProps {
  index: number;
  path: string;
  code: number;
  targetType?: string;
  target?: string;
  target_zuid?: string;
  query_string?: string;
  isLoading?: boolean;
  dispatch: (action: any) => void;
}
const RedirectImportTableRow = ({
  index,
  path,
  code,
  target,
  targetType,
  target_zuid,
  query_string,
  isLoading,
  dispatch
}: RedirectImportTableRowProps) => {
  const {
    t
  } = useTranslation();
  const [loading, setLoading] = useState(false);
  const handleCode = (val: string) => {
    dispatch(importCode(path, val));
  };
  const handlePathTarget = (evt: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    dispatch(importTarget(path, evt.target.value, ""));
  };
  const handleTargetType = (evt: SelectChangeEvent<string>) => {
    dispatch(importTargetType(path, evt.target.value));
  };
  const handleQuery = (evt: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    dispatch(importQuery(path, evt.target.value));
  };
  const handleAddRedirect = async (evt: React.MouseEvent<HTMLButtonElement>) => {
    setLoading(true);
    await dispatch(createRedirect({
      path: path,
      query_string: query_string,
      targetType: targetType,
      target: target_zuid || target,
      code: Number(code)
    }));
    setLoading(false);
  };
  const handleToggle = (val: string | null) => {
    if (val === null) return;
    handleCode(val);
  };
  return <Grid container spacing={3} width="100%" py={2.5} pl={2} pr={1} direction="row" sx={{
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "nowrap",
    color: "text.secondary",
    backgroundColor: index % 2 === 0 ? "transparent" : "grey.50"
  }} data-sentry-element="Grid" data-sentry-component="RedirectImportTableRow" data-sentry-source-file="RedirectImportTableRow.tsx">
      <Grid size="grow" minWidth="200px" data-sentry-element="Grid" data-sentry-source-file="RedirectImportTableRow.tsx">
        <Typography variant="body2" fontWeight={400} data-sentry-element="Typography" data-sentry-source-file="RedirectImportTableRow.tsx">
          {path}
        </Typography>
      </Grid>

      <Grid minWidth="115px" data-sentry-element="Grid" data-sentry-source-file="RedirectImportTableRow.tsx">
        <ToggleButtonGroup color="primary" value={code} size="small" exclusive onChange={(evt, val) => handleToggle(val)} data-sentry-element="ToggleButtonGroup" data-sentry-source-file="RedirectImportTableRow.tsx">
          <ToggleButton value={"302"} data-sentry-element="ToggleButton" data-sentry-source-file="RedirectImportTableRow.tsx">302</ToggleButton>
          <ToggleButton value={"301"} data-sentry-element="ToggleButton" data-sentry-source-file="RedirectImportTableRow.tsx">301</ToggleButton>
        </ToggleButtonGroup>
      </Grid>
      <Grid minWidth="130px" data-sentry-element="Grid" data-sentry-source-file="RedirectImportTableRow.tsx">
        <Select onChange={handleTargetType} size="small" fullWidth value={targetType} data-sentry-element="Select" data-sentry-source-file="RedirectImportTableRow.tsx">
          <MenuItem value={"path"} data-sentry-element="MenuItem" data-sentry-source-file="RedirectImportTableRow.tsx">{t("seo.redirectTypeWildcard")}</MenuItem>
          <MenuItem value={"page"} data-sentry-element="MenuItem" data-sentry-source-file="RedirectImportTableRow.tsx">{t("seo.redirectTypeInternal")}</MenuItem>
          <MenuItem value={"external"} data-sentry-element="MenuItem" data-sentry-source-file="RedirectImportTableRow.tsx">
            {t("seo.redirectTypeExternal")}
          </MenuItem>
        </Select>
      </Grid>

      <Grid size="grow" minWidth="200px" data-sentry-element="Grid" data-sentry-source-file="RedirectImportTableRow.tsx">
        <TextField onChange={handlePathTarget} defaultValue={target} size="small" variant="outlined" color="primary" fullWidth data-sentry-element="TextField" data-sentry-source-file="RedirectImportTableRow.tsx" />
        {targetType === "path" && <TextField onChange={handleQuery} placeholder={t("seo.redirectQueryStringPlaceholder")} defaultValue={query_string} size="small" variant="outlined" color="primary" fullWidth />}
      </Grid>

      <Grid width="115px" sx={{
      textAlign: "center"
    }} data-sentry-element="Grid" data-sentry-source-file="RedirectImportTableRow.tsx">
        <Button variant="contained" onClick={handleAddRedirect} startIcon={<AddIcon />} size="small" loading={isLoading || loading} data-sentry-element="Button" data-sentry-source-file="RedirectImportTableRow.tsx">
          {t("seo.redirectButton")}
        </Button>
      </Grid>
    </Grid>;
};
export default RedirectImportTableRow;